import {
  AlertDialog,
  ConfirmDialog,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { usePayoffRequestStore } from '../hooks/usePayoffRequestStore';
import { useBaseStore } from '@roc/feature-app-core';

export const RetractPayoffDialog = observer(({ loanId, loanPayoffDataId }) => {
  const { globalStore } = useBaseStore();
  const { payoffRequestStore } = usePayoffRequestStore();

  const retractPayoff = async () => {
    if (globalStore.isInternalPortal) {
      await payoffRequestStore.retractPayoffV2(loanId, loanPayoffDataId);
    } else {
      await payoffRequestStore.retractPayoffExternalV2(loanId, loanPayoffDataId);
    }
    if (!payoffRequestStore.currentPayoff && globalStore.isInternalPortal) {
      await payoffRequestStore.getPayoffById(loanId, payoffRequestStore.selectedPayoffId);
    }
    payoffRequestStore.setIsNewPayoffRetractModalOpen(false);
  };

  return (
    <>
      <ConfirmDialog
        open={payoffRequestStore.isNewPayoffRetractModalOpen}
        confirmButtonText='Confirm'
        handleClose={() => payoffRequestStore.setIsNewPayoffRetractModalOpen(false)}
        handleCancel={() => payoffRequestStore.setIsNewPayoffRetractModalOpen(false)}
        handleConfirm={async () => retractPayoff()}
        title={'Retract Payoff'}
        body={`You are retracting your payoff. Please confirm`}
      />
      <AlertDialog
        open={payoffRequestStore.isPayoffRetractedModalOpen}
        title='Thank you'
        body={'Your payoff request has been retracted.'}
        okButtonText='Close'
        handleClose={() => {
          payoffRequestStore.setIsPayoffRetractedModalOpen(false);
          payoffRequestStore.reset();
        }}
        maxWidth={'sm'}
      />
    </>
  );
});